import { useEffect, useRef } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import {
  $getNodeByKey,
  PASTE_COMMAND,
  COMMAND_PRIORITY_LOW,
  LexicalNode,
  $getSelection,
  $isRangeSelection,
  $isTextNode,
  $createParagraphNode,
  $createTextNode,
  $createRangeSelection,
  $setSelection,
  $getNearestNodeFromDOMNode,
  $getRoot,
  KEY_BACKSPACE_COMMAND,
  COMMAND_PRIORITY_EDITOR,
  $insertNodes,
  $isElementNode,
  $isParagraphNode,
} from "lexical";
import { $createLayoutItemNode, $isLayoutItemNode, getAllLayoutItemNodes, getLastPage, getSelectedPage, LayoutItemNode, setDefaultFooter, setDefaultHeader } from "../nodes/LayoutItemNode";
import { $generateNodesFromDOM } from "@lexical/html";
import { $createListNode } from "@lexical/list";
import { $createImageNode } from "../nodes/ImageNode";
import { addTableCaptions, alternateTableRowColors, indexTablesById, PastingData } from "../utils/editorstateHelper";
import { $getPageRoot, $isLayoutContainerNode } from "../nodes/LayoutContainerNode";
import { ColoredNode } from "../nodes/TableNode";
import { $createTableNode, $createTableNodeWithDimensions, $findCellNode, $findTableNode, $isTableNode, TableCellNode, TableNode, TableRowNode } from "../nodes/CustomTableNode/src";
import { generateStableCaptionId } from "./TablePlugin";
import { handlePaste } from "./ImagesPlugin";
import { $createHeadingNode, $isHeadingNode } from "../nodes/Heading-node-custom";
import { getColumnCountFromCell } from "../nodes/CustomTableNode/src/LexicalTableSelectionHelpers";
import { getLastTableNoForGroup } from "../nodes/CustomTableNode/src/LexicalTableNode";

export default function PageBehavior({ enableCaption, styleConfig, editId }: any) {
  const [editor] = useLexicalComposerContext();
  const headerRef = useRef<any>('Type a Header');
  const footerRef = useRef<any>('Type a Footer');
  const PasteRef = useRef<any>(false)
  const MAX_HEIGHT = 1000;
  const cellLenRef = useRef<any>()
  const CellChildRef = useRef<any>();
  let isSplited = false



  useEffect(() => {

    const handler = (event: any) => {
      const { key } = event.detail;

      editor.update(() => {
        const node: any = $getNodeByKey(key);
        const overFlowedElem = event.detail.overflowingContent
        const overFlowedNode = overFlowedElem;
        if (!node) return;

        const children = node.getChildren();
        if (children.length === 0) return;
        const newDiv = $createLayoutItemNode('custom-div');
        newDiv.setHeaderText(node.getHeaderText())
        newDiv.setFooterText(node.getFooterText())
        const midpoint = Math.floor(children.length / 2);
        const toMove: any = overFlowedNode
        const lastPage = getLastPage();
        const root = $getPageRoot();
        const selection = $getSelection();
        const prev = overFlowedElem.getPreviousSibling();
        const prev2 = prev ? prev.getPreviousSibling() : null;

        // for Table
        if($isTableNode(prev)){
          splitTableByRowsWithSameGroupId(prev)
        }
        if( prev2 && $isTableNode(prev2)){
          splitTableByRowsWithSameGroupId(prev2)
        }
        
        if (overFlowedElem.getType() === 'table' && lastPage === node) {
          if ($isRangeSelection(selection)) {
            const cell = $findCellNode(selection.anchor.getNode())
            if (cell) {
              const table = $findTableNode(cell);
              cellLenRef.current = cell.getChildren()[cell.getChildren().length - 1];
              CellChildRef.current = cell.getChildren().length;
              if (table && overFlowedElem === table) {
                const currSelCell = cell.getCellIndex();
                const currCellChild: any = cellLenRef.current
                const currCols = getColumnCountFromCell(cell)
                const insertionTable = $createTableNodeWithDimensions(1, currCols, false)
                insertionTable.setGroupId(table.getGroupId())
                const insertionRow: TableRowNode | null = insertionTable.getFirstChild();
                if (!insertionRow) return;
                const cellToInsert = insertionRow.getCellAtIndex(currSelCell)
                cellToInsert?.append(currCellChild)
                newDiv.append(insertionTable);
                root?.append(newDiv)
              } else {
                newDiv.append(overFlowedElem);
                root?.append(newDiv)
              }
            } else {
              newDiv.append(overFlowedElem);
              root?.append(newDiv)
            }
          }
        }
        else if (
          overFlowedElem.getType() === 'table'
          && node.getNextSibling() !== null
          && node.getNextSibling().getType() === 'layout-item'
          && node.getNextSibling()?.getClassName() === 'custom-div'
        ) {
          if ($isRangeSelection(selection)) {
            const cell = $findCellNode(selection.anchor.getNode());
            if (cell) {
              const cellElem = editor.getElementByKey(cell?.getLatest().getKey())
              const table = $findTableNode(cell);
              cellLenRef.current = cell.getChildren()[cell.getChildren().length - 1]
              if (table && overFlowedElem === table) {
                const tableIndex = table.getTableIndex()
                const lastIndex = getLastTableNoForGroup(table)
                const currSelCell = cell.getCellIndex();
                const currCellChild: any = cellLenRef.current
                const currCols = getColumnCountFromCell(cell)
                const insertionTable = $createTableNodeWithDimensions(1, currCols, false)
                insertionTable.setGroupId(table?.getGroupId())
                const insertionRow: TableRowNode | null = insertionTable.getFirstChild();
                if (!insertionRow) return;
                const cellToInsert = insertionRow.getCellAtIndex(currSelCell)
                cellToInsert?.append(currCellChild)
                const nextPage = node.getNextSibling();
                const nextFirstChild :TableNode= nextPage.getFirstChild();
                if (nextFirstChild && $isTableNode(nextFirstChild) && tableIndex === nextFirstChild.__tableIndex) {
                  const nextRow: TableRowNode | null = nextFirstChild.getFirstChild();
                  if (nextRow) {
                    const lastCHild = cellLenRef.current
                    const cellToInsert = nextRow.getCellAtIndex(currSelCell)
                    if (cellToInsert) {
                      const children1 = cellToInsert.getChildren()
                      if (children1.length > 0) {
                        children1[0].insertBefore(lastCHild);
                        if (lastCHild.getType() === selection.anchor.getNode()?.getType()) {
                          lastCHild.selectEnd();
                          if (isSplited === false) {
                            CellChildRef.current = cell.getChildren().length;
                            isSplited = true
                          }

                        }
                      } else {
                        cellToInsert.append(lastCHild);
                      }
                    }
                  }
                } else {
                  const newTable = $createTableNodeWithDimensions(1, currCols, false);
                  const caption = table.getIsCaption()
                  newTable.setTableIndex(tableIndex)
                  if (caption) {
                    newTable.setIsCaption(caption)
                  }
                  const newRow: TableRowNode | null = newTable.getFirstChild();
                  const child = cellLenRef.current
                  if (newRow) {
                    const insertCell = newRow.getCellAtIndex(currSelCell);
                    insertCell?.append(child)
                    const nextPage = node.getNextSibling();
                    const nextFirstChild :TableNode= nextPage.getFirstChild();
                    if (nextFirstChild) {
                if($isTableNode(nextFirstChild)){
                  mergeFollowingTablesWithSameGroupId(newTable)
                }
                      nextFirstChild.insertBefore(newTable)
                    }
                  }
                }
              }
              else {
                const nextPage = node.getNextSibling();
                const nextFirstChild :TableNode= nextPage.getFirstChild();
                if (nextFirstChild) {
                                  if($isTableNode(nextFirstChild)){
                  mergeFollowingTablesWithSameGroupId(overFlowedElem)
                }
                  nextFirstChild.insertBefore(overFlowedElem)
                }
              }
            } else {
              const nextPage = node.getNextSibling();
              const nextFirstChild = nextPage.getFirstChild();
              if (nextFirstChild) {
                if($isTableNode(nextFirstChild)){
                  mergeFollowingTablesWithSameGroupId(overFlowedElem)
                }
                nextFirstChild.insertBefore(overFlowedElem)
              }
            }
          }
        }

        //for table end

        if (overFlowedElem.getType() === 'paragraph' && lastPage === node) {
          const newPara = $createParagraphNode();
          const children = overFlowedElem.getChildren();
          if (children.length > 0) {
            newPara.append(...children)
          } else {
            const text = $createTextNode('');
            newPara.append(text)
          }
          newDiv.append(newPara)
          root?.append(newDiv)
        } else if ($isParagraphNode(overFlowedElem) && node.getNextSibling() !== null && node.getNextSibling().getType() === 'layout-item' && node.getNextSibling()?.getClassName() === 'custom-div') {
          const nextPage = node.getNextSibling();
          const firstChild = nextPage.getFirstChild();
          if (firstChild) {
            firstChild.insertBefore(overFlowedElem)
          } else {
            nextPage.append(overFlowedElem)
          }
        }

        if ($isHeadingNode(overFlowedElem) && lastPage === node) {
          const newHeading = $createHeadingNode(overFlowedElem.getTag())
          const headChild = overFlowedElem.getChildren();
          if (headChild.length > 0) {
            newHeading.append(...headChild)
          } else {
            const text = $createTextNode('');
            newHeading.append(text)
          }
          newDiv.append(newHeading);
          overFlowedElem.remove()
          root?.append(newDiv)
        } else if ($isHeadingNode(overFlowedElem) && node.getNextSibling() !== null && node.getNextSibling().getType() === 'layout-item' && node.getNextSibling()?.getClassName() === 'custom-div') {
          const nextPage = node.getNextSibling();
          const firstChild = nextPage.getFirstChild();
          if (firstChild) {
            firstChild.insertBefore(overFlowedElem)
          } else {
            nextPage.append(overFlowedElem)
          }
        }

        if (!$isTableNode(overFlowedElem) && !$isHeadingNode(overFlowedElem) && !$isParagraphNode(overFlowedElem) && node.getNextSibling() !== null && node.getNextSibling().getType() === 'layout-item' && node.getNextSibling()?.getClassName() === 'custom-div' && !$isTableNode(overFlowedElem)) {
          const nextpage = node.getNextSibling();
          const nextPageChildren = (nextpage as LayoutItemNode).getChildAtIndex(0)
          if (nextPageChildren) {
            nextPageChildren.insertBefore(toMove)
          }

        }
        else if (!$isTableNode(overFlowedElem) && !$isHeadingNode(overFlowedElem) && !$isParagraphNode(overFlowedElem)) {
          const firstChild = newDiv.getChildAtIndex(0)
          if (firstChild === null) {
            newDiv.append(toMove)
          } else {
            firstChild.insertBefore(toMove)
          }
          // if(getSelectedPage()?.getLatest().getKey() === node.getLatest().getKey()){
          //   const root = $getPageRoot()
          //   root?.append(newDiv)
          //   console.log('fdghfdjkg',getSelectedPage()?.getLatest().getKey(),node.getLatest().getKey())
          // }else{
          node.insertAfter(newDiv);
          // }
        }
      });
      // }
    };

    document.addEventListener("DivNodeOverflow", handler);

    const unregisterPaste = editor.registerCommand(
      PASTE_COMMAND,
      (event: ClipboardEvent) => {
        const selection = $getSelection();
        if (!$isRangeSelection(selection)) {
          return false;
        }

        const anchor = selection.anchor.getNode();
        const table = $findTableNode(anchor);
        const clipboardData = event.clipboardData;
        if (!clipboardData) return false;
        PasteRef.current = true
        const html = clipboardData.getData('text/html');
        const text = clipboardData.getData('text/plain');

        if (html.length === 0) {
          handlePaste(event, editor, '', enableCaption, editId, styleConfig)
        }


        const isLargePaste = (text && text.length > 5000);
        const isPagination = $getPageRoot();
        event.preventDefault();

        editor.update(() => {
          const currentPage = getSelectedPage();
          if (currentPage) {
            selection.removeText();

            let nodes: LexicalNode[] = [];
            const tableStyles = styleConfig.tableStyles ? styleConfig.tableStyles :
              {
                headerColor: "white",
                rowColor: 'white'
              }


            const parser = new DOMParser();
            const coloredTables = alternateTableRowColors(html, tableStyles.headerColor, tableStyles.rowColor)
            const indexed = indexTablesById(coloredTables)
            const data = addTableCaptions(indexed,styleConfig)
            const doc = parser.parseFromString(enableCaption ? data : indexed, 'text/html');

            const generatedNodes = $generateNodesFromDOM(editor, doc);

            nodes.push(...generatedNodes);


            if (isLargePaste && !$isTableNode(table)) {
              nodes = nodes.filter(node => !$isLayoutItemNode(node));

              if (nodes.length === 0) return;

              const nodesPerPage = 20;
              let targetPage = currentPage;
              let nodeCount = 0;

              const anchorNode = selection.anchor.getNode();
              let insertionPoint: LexicalNode | null = anchorNode.getParent() || anchorNode;

              nodes.forEach((node, index) => {
                if (nodeCount >= nodesPerPage && index < nodes.length - 1) {
                  const newPage = $createLayoutItemNode('custom-div');
                  newPage.setHeaderText(targetPage.getHeaderText());
                  newPage.setFooterText(targetPage.getFooterText());
                  targetPage.insertAfter(newPage);
                  targetPage = newPage;
                  nodeCount = 0;
                  insertionPoint = null;
                }

                if (insertionPoint && $isElementNode(insertionPoint) && insertionPoint.getParent() === targetPage) {
                  insertionPoint.insertAfter(node);
                  insertionPoint = node;
                } else {
                  targetPage.append(node);
                  insertionPoint = node;
                }

                nodeCount++;
              });
            }
            else {
              selection.insertNodes(generatedNodes)
            }
            PastingData(editor, enableCaption, styleConfig, true)
          }
        });

        return isPagination ? true : false;
      },
      4
    );



    return () => {
      document.removeEventListener("DivNodeOverflow", handler);
      unregisterPaste();
    };
  }, [editor]);


  const headerSave = () => {
    editor.update(() => {
      const allPage = getAllLayoutItemNodes()
      if (allPage) {
        allPage.forEach((page: any) => {
          page.setHeaderText(headerRef.current)
          if (headerRef.current.length < 1) {
            page.setHeaderText('Type a Header')
          }
        })
      }
    })
  }
  const footerSave = () => {
    editor.update(() => {
      const allPage = getAllLayoutItemNodes()
      if (allPage) {
        allPage.forEach((page: any) => {
          page.setFooterText(footerRef.current)
          if (footerRef.current === '') {
            page.setFooterText('Type a Footer')
          }
        })
      }
    })
  }

  useEffect(() => {
    const handleInputDoubleClicked = (e: any) => {
      editor.update(() => {
        const { type, id } = e.detail;

        if (type !== 'header' && type !== 'footer') return;

        editor.setEditable(false);

        const headerInputs = document.querySelectorAll('.Header-Input');
        const footerInputs = document.querySelectorAll('.Footer-Input');

        [...headerInputs, ...footerInputs].forEach((input: any) => {
          input.disabled = false;
        });

        const selectedInput = document.getElementById(id);
        if (selectedInput) {
          selectedInput.focus();

          selectedInput.addEventListener('blur', () => {
            if (type === 'header') {
              headerSave();
              (selectedInput as HTMLInputElement).disabled = true
            } else if (type === 'footer') {
              (selectedInput as HTMLInputElement).disabled = true
              footerSave();
            }
          });

          const ref = type === 'header' ? headerRef : footerRef;
          const inputs = type === 'header' ? headerInputs : footerInputs;

          inputs.forEach((input) => {
            input.addEventListener('input', (e: any) => {
              const value = e.target.value;
              ref.current = value;

              inputs.forEach((otherInput: any) => {
                if (otherInput !== e.target) {
                  otherInput.value = value;
                }
              });
            });
          });
        }
      });
    };

    document.addEventListener('InputDoubleClicked', handleInputDoubleClicked);

    return () => {
      document.removeEventListener('InputDoubleClicked', handleInputDoubleClicked);
    };
  }, []);


  useEffect(() => {
    const handleKeyDown = (event: any) => {
      if (event.key === 'Backspace') {

        editor.update(() => {
          const currentPage = getSelectedPage();
          if (currentPage) {
            const isEmpty = currentPage.getChildren().length < 2;
            if (isEmpty) {
              deletPage();
            }
            else {
              const nextPage = currentPage.getNextSibling();
              const selection = $getSelection()
              if (!$isRangeSelection(selection)) return
              const anchor = selection.anchor.getNode()
              const text = anchor.getTextContent()
              const caretPostion = selection.anchor.offset
              const textBeforeCaret = text.slice(0, caretPostion);
              const isCaretAtStart = textBeforeCaret.length === 0
              const isFirstAtSelection = currentPage && currentPage.getFirstChild() !== null && (currentPage as LayoutItemNode).getFirstChild()?.getLatest().getKey() === anchor.getParent()?.getLatest().getKey() === true ? currentPage && currentPage.getFirstChild() !== null && (currentPage as LayoutItemNode).getFirstChild()?.getLatest().getKey() === anchor.getParent()?.getLatest().getKey() : currentPage && currentPage.getFirstChild() !== null && (currentPage as LayoutItemNode).getFirstChild()?.getLatest().getKey() === anchor.getLatest().getKey()
              if (nextPage && !isFirstAtSelection && isCaretAtStart) {
                const firstChild = (nextPage as LayoutItemNode).getChildAtIndex(0)
                const MAX_HEIGHT = 1124;
                let totalHeight: any = 0
                const currentElem = editor.getElementByKey(currentPage.getLatest().getKey())
                if (currentElem) {
                  currentElem.childNodes.forEach((child: any) => {
                    if (
                      child instanceof HTMLElement &&
                      !child.classList.contains('Header-Input') &&
                      !child.classList.contains('Footer-Input') &&
                      !child.classList.contains('PlaygroundEditorTheme__layoutContainer')
                    ) {
                      totalHeight += child.offsetHeight;
                      const spaceLeft = MAX_HEIGHT - totalHeight
                      if (spaceLeft > 74) {
                        if (firstChild) {
                          currentPage.append(firstChild)
                          if ((nextPage as LayoutItemNode).getChildren().length === 0) {
                            nextPage.remove()
                          }
                        }
                      }
                    }
                  })
                }
              } else if (nextPage && isCaretAtStart === true) {
                const currentPage = getSelectedPage()
                if (!currentPage) return;
                const firstChild = currentPage.getChildAtIndex(0)
                const prevPage = currentPage.getPreviousSibling()
                if (!prevPage || !firstChild) return
                (prevPage as LayoutItemNode).append(firstChild)
              }
              else if (!nextPage && isCaretAtStart) {
                const currentPage = getSelectedPage()
                if (!currentPage) return;
                const firstChild = currentPage.getChildAtIndex(0)
                const prevPage = currentPage.getPreviousSibling()
                if (!prevPage || !firstChild) return
                (prevPage as LayoutItemNode).append(firstChild)
              }
            }
          }
        })
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [editor, getSelectedPage]);


  const deletPage = () => {
    editor.update(() => {
      const selPage = getSelectedPage();
      if (selPage) {
        const children = selPage.getChildren()
        const prevPage = selPage.getPreviousSibling()
        if (!prevPage) return
        children.forEach((child: any) => {
          (prevPage as LayoutItemNode).append(child)
        })
        prevPage.selectEnd()
        selPage.remove()
      }
    })
  }

  const ap = () => {
    editor.update(() => {
      const sel = getSelectedPage()
      if (sel) {
        const paragraph = $createParagraphNode()
        const text = $createTextNode('text insert using append in sel page')
        paragraph.append(text)
        sel.append(paragraph)
      }
    })
  }

  useEffect(() => {
    const handleCopy = (event: any) => {

      const selection = window.getSelection();
      if (!selection || selection.isCollapsed) {
        console.warn("⚠️ No text selected to copy");
        return;
      }

      const container = document.createElement("div");

      for (let i = 0; i < selection.rangeCount; i++) {
        container.appendChild(selection.getRangeAt(i).cloneContents());
      }

      container.querySelectorAll(".custom-div").forEach((el) => {
        const parent = el.parentNode;
        if (!parent) return;

        while (el.firstChild) {
          parent.insertBefore(el.firstChild, el);
        }

        parent.removeChild(el);
      });
      const selectionColors = [
        "rgb(0, 120, 215)",   // Windows selection blue
        "rgb(61, 153, 255)",  // macOS selection blue
        // Add other colors here if needed
      ];

      // Remove only selection blue backgrounds, keep others (like pink!)
      container.querySelectorAll<HTMLElement>("*").forEach((el) => {
        const bg = el.style.backgroundColor;
        if (bg && selectionColors.includes(bg)) {
          el.style.backgroundColor = "";
        }
      });

      const htmlContent = container.innerHTML.trim();
      const textContent = container.innerText.trim();

      if (!htmlContent && !textContent) {
        console.warn("⚠️ Nothing to copy");
        return;
      }

      event.preventDefault();

      const clipboardData = event.clipboardData;
      if (clipboardData) {
        clipboardData.setData("text/html", htmlContent);
        clipboardData.setData("text/plain", textContent);
      } else {
        console.error("❌ Clipboard data is not available.");
      }
    };

    window.addEventListener("copy", handleCopy);

    return () => {
      window.removeEventListener("copy", handleCopy);
    };
  }, []);

  function mergeTablesContent(firstTable: TableNode, secondTable: TableNode) {
    editor.update(() => {
      const firstRow: TableRowNode | null = firstTable.getFirstChild();
      const secondRow: TableRowNode | null = secondTable.getFirstChild();

      if (!firstRow || !secondRow) return;

      const firstRowCells = firstRow.getChildren();
      let targetCell: TableCellNode | any = firstRowCells[firstRowCells.length - 1];

      const secondRowCells = secondRow.getChildren();

      secondRowCells.forEach((secondCell: any) => {
        const children = secondCell.getChildren();

        // If no target cell exists, skip
        if (!targetCell) return;

        // Append content (paragraphs, text, etc.) into target cell
        children.forEach((child: any) => {
          targetCell.append(child);
        });
      });

      // Remove the second table entirely
      secondTable.remove();
    });
  }





  const splitTableAtSelByRowsWithSameGroupId = () => {
    editor.update(() => {
      const selection = $getSelection();
      if (!$isRangeSelection(selection)) return;

      const cell = $findCellNode(selection.anchor.getNode());
      if (!cell) return;

      const table = $findTableNode(cell);
      if (!table) return;

      const groupId = table.getGroupId();
      const parent = table.getParent();
      if (!parent) return;

      const rows = table.getChildren<TableRowNode>();
      if (rows.length <= 1) return; // nothing to split

      let insertAfter: TableNode | null = table;

      rows.forEach((row, index) => {
        // Detach row first
        row.remove();

        const newTable = $createTableNode(false, groupId);
        newTable.append(row);

        if (index === 0) {
          // Replace original table with first split table
          table.insertBefore(newTable);
        } else if (insertAfter) {
          insertAfter.insertAfter(newTable);
        }

        insertAfter = newTable;
      });

      // Remove the original table
      table.remove();

      // Restore selection
      cell.select();
    });
  };

// const splitTableByRowsWithSameGroupId = (table: TableNode) => {
//   editor.update(() => {
//     if (!table) return;

//     const groupId = table.getGroupId();
//     const parent = table.getParent();
//     if (!parent) return;

//     const rows = table.getChildren<TableRowNode>();
//     if (rows.length <= 1) return; // nothing to split

//     let insertAfter: TableNode | null = table;

//     rows.forEach((row, index) => {
//       // Detach row first
//       row.remove();

//       const newTable = $createTableNode(false, groupId);
//       newTable.append(row);

//       if (index === 0) {
//         // Replace original table with first split table
//         table.insertBefore(newTable);
//       } else if (insertAfter) {
//         insertAfter.insertAfter(newTable);
//       }

//       insertAfter = newTable;
//     });

//     // Remove the original table
//     table.remove();
//   });
// };


const splitTableByRowsWithSameGroupId = async (table: TableNode) => {
  if (!table) return;

  await new Promise<void>((resolve) => {
    editor.update(() => {
      const groupId = table.getGroupId();
      const parent = table.getParent();
      if (!parent) {
        resolve();
        return;
      }

      const rows = table.getChildren<TableRowNode>();
      if (rows.length <= 1) {
        resolve();
        return; // nothing to split
      }

      let insertAfter: TableNode | null = table;

      rows.forEach((row, index) => {
        // Detach row first
        row.remove();

        const newTable = $createTableNode(false, groupId);
        newTable.append(row);

        if (index === 0) {
          // Replace original table with first split table
          table.insertBefore(newTable);
        } else if (insertAfter) {
          insertAfter.insertAfter(newTable);
        }

        insertAfter = newTable;
      });

      // Remove the original table
      table.remove();

      resolve(); // finish the promise after the update
    });
  });
};




const mergeFollowingTablesWithSameGroupId = (selectedTable: TableNode) => {
  editor.update(() => {
    if (!selectedTable) return;
    const targetGroupId = selectedTable.getGroupId();
    const root = $getPageRoot();
    if (!root) return;

    const allTables: TableNode[] = [];

    const collectTables = (node: LexicalNode) => {
      if($isLayoutContainerNode(node)){
        node.getAllChildren().forEach((n)=>collectTables(n));
      }
      if ($isTableNode(node) && node.getGroupId() === selectedTable.getGroupId()) {
        allTables.push(node)
      }
      // else if ($isElementNode(node)) node.getChildren().forEach(collectTables);
    };

    collectTables(root);

    let foundSelected = false;
    const tablesToMerge: TableNode[] = [];

    allTables.forEach((table) => {
      if (table.getKey() === selectedTable.getKey()) {
        foundSelected = true;
        return;
      }
      if (foundSelected && table.getGroupId() === targetGroupId) {
        tablesToMerge.push(table);
      }
    });

    if (tablesToMerge.length === 0) return;

    tablesToMerge.forEach((table) => {
      table.getChildren<TableRowNode>().forEach((row) => {
        row.remove();
        selectedTable.append(row);
      });
      table.remove();
    });
  });
};







  const mergeAllTableAtSelsWithSameGroupId = () => {
    editor.update(() => {
      const selection = $getSelection();
      if (!$isRangeSelection(selection)) return;

      const cell = $findCellNode(selection.anchor.getNode());
      if (!cell) return;

      const selectedTable = $findTableNode(cell);
      if (!selectedTable) return;

      const targetGroupId = selectedTable.getGroupId();
      const root = $getPageRoot();
      if (!root) return;
      const allTables: TableNode[] = [];

      // 1️⃣ Collect all tables from the root
      root.getAllChildren().forEach((node) => {
        if ($isTableNode(node)) {
          allTables.push(node);
        }
      });

      // 2️⃣ Filter tables with same groupId
      const tablesToMerge = allTables.filter(
        (table) => table.getGroupId() === targetGroupId
      );

      // Nothing to merge
      if (tablesToMerge.length <= 1) return;

      // 3️⃣ Merge into the first table (document order)
      const baseTable = tablesToMerge[0];

      for (let i = 1; i < tablesToMerge.length; i++) {
        const table = tablesToMerge[i];
        const rows = table.getChildren<TableRowNode>();

        rows.forEach((row: any) => {
          row.remove();
          baseTable.append(row);
        });

        table.remove();
      }

      // 4️⃣ Restore selection
      cell.select();
    });
  };


  return (
    <></>
  );
}
